module.exports = __webpack_public_path__ + "img/rossanax2.13e4649c.jpg";